import ClientModel                     from 'Models/directory/ClientModel';
import OwnerModel                      from 'Models/intervention/OwnerModel';
import TaskGroupModel                  from 'Models/intervention/TaskGroupModel';
import TaskHolderModel                 from 'Models/intervention/TaskHolderModel';
import TaskLevelModel                  from 'Models/intervention/TaskLevelModel';
import TaskStatusModel                 from 'Models/intervention/TaskStatusModel';
import SourceModel                     from 'Models/invoice/SourceModel';
import ContractIterationItemEventModel from 'Models/sales/ContractIterationItemEventModel';
import QuotationItemEventModel         from 'Models/sales/QuotationItemEventModel';
import QuotationRequestModel           from 'Models/sales/QuotationRequestModel';
import doc                             from 'decorators/doc';
import model                           from 'decorators/model';
import { Blamable }                    from 'helpers/traits';
import { Timestampable }               from 'helpers/traits';
import InterventionPrivateApiModel     from 'modelx/models/abstracts/InterventionPrivateApiModel';

const customDoc = doc;

@model.staticLabel('Tâche', false)
@model.urnResource('task')
@doc.path('/tasks/{?id}')
export default class TaskModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'owner.clientUrn': Urn;
		'owner.enterprisePartitionUrn': Urn;
		'owner.enterpriseUrn': Urn;
		'owner.ownerSubPartition': id;
		'owner.ownerSubPartition.partitionUrn': Urn;
		'owner.ownerSubPartition.subPartitionUrn': Urn;
		'scheduleEndDate[after]': string | Date;
		'scheduleEndDate[before]': string | Date;
		'scheduleEndDate[strictly_after]': string | Date;
		'scheduleEndDate[strictly_before]': string | Date;
		'scheduleStartDate[after]': string | Date;
		'scheduleStartDate[before]': string | Date;
		'scheduleStartDate[strictly_after]': string | Date;
		'scheduleStartDate[strictly_before]': string | Date;
		'sourceUrn': Urn;
		'tags[serviceUrn][tagReference]': id;
		'taskGroup': id;
		'taskGroup.sourceUrn': Urn;
		'taskHolder': id;
		'taskHolder.holderUrn': Urn;
		'taskHolder.tags[serviceUrn][tagReference]': id;
		'taskLevel': id;
		'taskLevel.reference': InterventionTaskLevelReference;
		'taskOperations': id;
		'taskOperations.operation': id;
		'taskOperations.operation.operationType.operationCategory': id;
		'taskOperations.tags[serviceUrn][tagReference]': id;
		'taskOperations.taskOperationArticles': id;
		'taskOperations.taskOperationTimelogs': id;
		'taskOperations.taskZone': id;
		'taskStatus': id;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'scheduleEndDate': string;
		'scheduleStartDate': string;
		'taskLevel.label': string;
		'taskLevel.level': string;
		'title': string;
		'updatedAt': string;
	}> = {};

	@doc.modelUrn(ClientModel) declare client: ClientModel;
	@doc.string declare description: string;
	@doc.string declare note: string;
	@doc.model(OwnerModel) declare owner: OwnerModel;
	@doc.date declare scheduleEndDate: Moment;
	@doc.date declare scheduleStartDate: Moment;
	@doc.model(TaskGroupModel) declare taskGroup: TaskGroupModel;
	@doc.model(TaskHolderModel) declare taskHolder: TaskHolderModel;
	@doc.model(TaskLevelModel) declare taskLevel: TaskLevelModel;
	@doc.model(TaskStatusModel) declare taskStatus: TaskStatusModel;
	@doc.string declare title: string;

	@customDoc.modelUrn(SourceModel) declare source: QuotationItemEventModel | ContractIterationItemEventModel | QuotationRequestModel | SourceModel;

	@model.nestedResolvable()
	public get subPartition() {
		return this.owner.ownerSubPartition.subPartition;
	}
}